import { useContext } from 'react';
import { FileSystemContext } from './FileSystemContext';
export const useActiveWorkspace = () => useContext(FileSystemContext);
